import React from "react";
import { ErrorMessage, Field } from "formik";
import { practitionerApproachSchema } from "ps-shared";
import * as yup from "yup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle";

import { FormGroup, Label, UncontrolledTooltip } from "reactstrap";

type TherapeuticApproachSchema = yup.InferType<typeof practitionerApproachSchema>;
interface TherapeuticApproachProps {
  values: TherapeuticApproachSchema;
}

export default class TherapeuticApproachForm extends React.Component<TherapeuticApproachProps> {
  // tslint:disable:max-line-length
  public render() {
    return (
      <>
        <FormGroup className="mb-3">
          <Label for="bio">Biography:</Label>
          <br />
          <Field
            placeholder="Tell us about yourself! :)"
            type="text"
            component="textarea"
            rows="10"
            name="bio"
            className="form-control"
          />
          <ErrorMessage name="bio" component="div" className="position-relative form-feedback" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="approach">Therapeutic Approach:</Label>
          <br />
          <Field
            placeholder="Describe your therapeutic approach..."
            type="text"
            name="approach"
            component="textarea"
            rows="10"
            className="form-control"
          />
          <ErrorMessage name="approach" component="div" className="position-relative form-feedback" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="work">How I work with Clients:</Label>
          <br />
          <Field
            placeholder="How do you work with clients?"
            type="text"
            name="work"
            component="textarea"
            rows="10"
            className="form-control"
          />
          <ErrorMessage name="work" component="div" className="position-relative form-feedback" />
        </FormGroup>
        <FormGroup className="mb-3">
          <UncontrolledTooltip delay={0} placement="right" target="programsTT">
            For example, ongoing integration programs ( intended audience, cost, who qualifies, location, schedule).
            Also, consider to add a group profile in our community group directory!
          </UncontrolledTooltip>
          <Label for="programs">Programs offered:</Label>&nbsp;&nbsp;
          <span id="programsTT" style={{ fontSize: "10px" }}>
            <FontAwesomeIcon icon={faInfoCircle} />
          </span>
          <br />
          <Field
            placeholder="Describe any programs you offer at your practice"
            type="text"
            name="programs"
            component="textarea"
            rows="10"
            className="form-control"
          />
          <ErrorMessage name="programs" component="div" className="position-relative form-feedback" />
        </FormGroup>
      </>
    );
  }
}
